export default {
    // 워커 출력 여부
    isOpenModalWorkerInfo: 0,
};
